module.exports = __webpack_public_path__ + "VC.png?9434d089ac38afbf3a3ff4b84c6131d1";